import PropTypes from 'prop-types';
import { useCoDriverScope } from 'site-modules/shared/hooks/use-co-driver-scope';

export function IgnoreRenderWhenCoDriver({ children = null }) {
  const isInCoDriver = useCoDriverScope();

  if (isInCoDriver) {
    return null;
  }

  return children;
}

IgnoreRenderWhenCoDriver.propTypes = {
  children: PropTypes.node,
};
